// extracted by mini-css-extract-plugin
export default {"title":"_0535e0a351","inner_title":"_5b91f836f1","charge_btn":"f063e99042"};